var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 255,
    viewBox: "0 0 284 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.2895 245.326L0 254.278V29.9523L95.2895 21.0006V245.326Z",
    fill: "url(#paint0_linear_1_720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2894 245.326L190.579 254.278V29.9523L95.2894 21.0006V245.326Z",
    fill: "url(#paint1_linear_1_720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 245.326L190.579 254.278V29.9523L284 21.0006V245.326Z",
    fill: "url(#paint2_linear_1_720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.627 239.099L3.03577 247.7V32.1602L95.627 23.5588V239.099Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6271 239.099L188.218 247.7V32.1602L95.6271 23.5588V239.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.809 239.099L188.218 247.7V32.1602L280.809 23.5588V239.099Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M95.627 43.3535L25.2982 45.8211V55.4345V68.5893V78.2028H85.0016V66.4945L95.627 66.1217L111.818 71.1193V48.3511L95.627 43.3535Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M95.6271 224.426L16.6969 232.016V203.176L95.6271 195.586V224.426Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M86.9879 135.155L8.05774 142.745V113.905L86.9879 106.315V135.155Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M176.581 202.164H142.176V228.474H176.581V202.164Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M165.382 140.41H130.977V166.72H165.382V140.41Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M179.461 58.1783H145.055V84.4884H179.461V58.1783Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M267.654 216.331L214.022 220.884V185.973L267.654 181.419V216.331Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M261.255 93.4631L207.623 98.0169V63.1055L261.255 58.5518V93.4631Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.639 28.6012C256.639 41.118 234.759 76.564 234.759 76.564C234.759 76.564 212.879 41.118 212.879 28.6012C212.879 16.0843 222.675 5.93738 234.759 5.93738C246.843 5.93738 256.639 16.0843 256.639 28.6012Z",
    fill: "url(#paint3_linear_1_720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.759 33.8716C238.412 33.8716 241.373 30.804 241.373 27.0198C241.373 23.2356 238.412 20.168 234.759 20.168C231.105 20.168 228.144 23.2356 228.144 27.0198C228.144 30.804 231.105 33.8716 234.759 33.8716Z",
    fill: "url(#paint4_linear_1_720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.005 28.6418C255.005 39.8237 234.758 71.4893 234.758 71.4893C234.758 71.4893 214.512 39.8237 214.512 28.6418C214.512 23.272 216.645 18.1222 220.442 14.3252C224.239 10.5283 229.389 8.39514 234.758 8.39514C240.128 8.39514 245.278 10.5283 249.075 14.3252C252.872 18.1222 255.005 23.272 255.005 28.6418Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.759 33.3502C238.139 33.3502 240.88 30.6097 240.88 27.2291C240.88 23.8485 238.139 21.108 234.759 21.108C231.378 21.108 228.637 23.8485 228.637 27.2291C228.637 30.6097 231.378 33.3502 234.759 33.3502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1057 170.438C72.1057 183.043 49.5764 218.739 49.5764 218.739C49.5764 218.739 27.047 183.043 27.047 170.438C27.047 157.832 37.1337 147.614 49.5764 147.614C62.019 147.614 72.1057 157.832 72.1057 170.438Z",
    fill: "url(#paint5_linear_1_720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5761 175.745C53.3378 175.745 56.3873 172.656 56.3873 168.845C56.3873 165.034 53.3378 161.945 49.5761 161.945C45.8144 161.945 42.7649 165.034 42.7649 168.845C42.7649 172.656 45.8144 175.745 49.5761 175.745Z",
    fill: "url(#paint6_linear_1_720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8229 170.311C69.8229 181.493 49.5762 213.159 49.5762 213.159C49.5762 213.159 29.3296 181.493 29.3296 170.311C29.3285 167.652 29.8514 165.018 30.8685 162.561C31.8855 160.103 33.3767 157.87 35.2568 155.989C37.137 154.109 39.3694 152.616 41.8263 151.598C44.2833 150.58 46.9167 150.057 49.5762 150.057C52.2357 150.057 54.8692 150.58 57.3261 151.598C59.7831 152.616 62.0154 154.109 63.8956 155.989C65.7758 157.87 67.267 160.103 68.284 162.561C69.301 165.018 69.8239 167.652 69.8228 170.311H69.8229Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5762 175.02C52.9567 175.02 55.6972 172.279 55.6972 168.899C55.6972 165.518 52.9567 162.778 49.5762 162.778C46.1956 162.778 43.4551 165.518 43.4551 168.899C43.4551 172.279 46.1956 175.02 49.5762 175.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.572 171.911C179.572 183.093 159.325 214.759 159.325 214.759C159.325 214.759 139.078 183.093 139.078 171.911C139.077 169.252 139.6 166.618 140.617 164.161C141.634 161.703 143.125 159.47 145.006 157.589C146.886 155.708 149.118 154.216 151.575 153.198C154.032 152.18 156.665 151.656 159.325 151.656C161.984 151.656 164.618 152.18 167.075 153.198C169.532 154.216 171.764 155.708 173.644 157.589C175.525 159.47 177.016 161.703 178.033 164.161C179.05 166.618 179.573 169.252 179.572 171.911Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.325 176.62C162.706 176.62 165.446 173.879 165.446 170.499C165.446 167.118 162.706 164.378 159.325 164.378C155.944 164.378 153.204 167.118 153.204 170.499C153.204 173.879 155.944 176.62 159.325 176.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.924 159.112C258.924 170.294 238.677 201.96 238.677 201.96C238.677 201.96 218.43 170.294 218.43 159.112C218.43 153.743 220.563 148.593 224.36 144.796C228.157 140.999 233.307 138.866 238.677 138.866C244.047 138.866 249.196 140.999 252.993 144.796C256.79 148.593 258.924 153.743 258.924 159.112Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.677 163.821C242.057 163.821 244.798 161.081 244.798 157.7C244.798 154.319 242.057 151.579 238.677 151.579C235.296 151.579 232.556 154.319 232.556 157.7C232.556 161.081 235.296 163.821 238.677 163.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0618 20.2466C80.0618 31.4285 59.8151 63.0941 59.8151 63.0941C59.8151 63.0941 39.5685 31.4285 39.5685 20.2466C39.5674 17.5871 40.0903 14.9535 41.1074 12.4961C42.1244 10.0387 43.6156 7.80581 45.4957 5.92489C47.3759 4.04396 49.6082 2.55189 52.0652 1.5339C54.5222 0.515905 57.1556 -0.00805664 59.8151 -0.00805664C62.4746 -0.00805664 65.1081 0.515905 67.565 1.5339C70.022 2.55189 72.2543 4.04396 74.1345 5.92489C76.0147 7.80581 77.5059 10.0387 78.5229 12.4961C79.5399 14.9535 80.0628 17.5871 80.0617 20.2466H80.0618Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8153 24.955C63.1959 24.955 65.9364 22.2145 65.9364 18.834C65.9364 15.4534 63.1959 12.7129 59.8153 12.7129C56.4347 12.7129 53.6942 15.4534 53.6942 18.834C53.6942 22.2145 56.4347 24.955 59.8153 24.955Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_720",
    x1: 47.6448,
    y1: 254.278,
    x2: 47.6448,
    y2: 21.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_720",
    x1: 42662.7,
    y1: 185406,
    x2: 42662.7,
    y2: 15331.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_720",
    x1: 69472,
    y1: 185406,
    x2: 69472,
    y2: 15331.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_720",
    x1: 234.759,
    y1: 76.564,
    x2: 234.759,
    y2: 5.93738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_720",
    x1: 234.759,
    y1: 33.8716,
    x2: 234.759,
    y2: 20.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55135,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_720",
    x1: 14046.9,
    y1: 52516.3,
    x2: 14046.9,
    y2: 36705.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_720",
    x1: 49.5761,
    y1: 175.745,
    x2: 49.5761,
    y2: 161.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00541,
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55135,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 254.278,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4236a70c56c7ff17044e1d2ba9c85537.svg";
export { ForwardRef as ReactComponent };